import moment from 'moment-timezone';
import download from 'downloadjs';
import { allPass, equals, ifElse, always } from 'ramda';
import snakeCase from 'lodash/snakeCase';
import toLower from 'lodash/toLower';
import config from '../../../config';
import { SHOP_CURRENCY } from '../shops/constants';
import { grossSalesKinds } from './constants';

const COLORS = ['var(--primaryColor)', 'var(--primaryColorDark)', '#445952', '#7e8e7f', '#bea278'];

// eslint-disable-next-line import/prefer-default-export
export const getColor = index => COLORS[index % COLORS.length];

export const downloadCsv = (response, name, extension = 'csv') => download(
  response,
  `${snakeCase(toLower(name))}.${extension}`,
  'text/plain'
);
export const downloadExcel = (response, name, extension = 'xlsx') => download(
  response,
  `${snakeCase(toLower(name))}.${extension}`
);
export const downloadZip = (response, name, extension = 'zip') => download(
  response,
  `${snakeCase(toLower(name))}.${extension}`,
  'application/zip'
);
export const mapPayoutReport = ({ serviceReport, productReport }) => {
  const services = serviceReport.map(item => ({
    Name: item.barberName,
    Card: item.card,
    Cash: item.cash,
    'Gift Card': item.giftCard,
    'GC Bought': item.giftCardForCommission,
    Total: item.total,
    'Barber Commission': item.barberCommission,
    'Squire Tips': item.squireTips,
    'POS Tips': item.posTips,
    'Cash Tips': item.cashTips,
    'Gift Card Tips': item.giftCardTips,
    Tips: item.tips,
    'Due to Barbers': item.dueToBarber,
    TaxAmount: item.taxAmount,
    'Due To Shop': item.dueToShop,
    commissionPercentage: item.commissionPercentage,
    'Hours Worked': item.totalTimeTracked,
  }));

  const products = productReport.map(item => ({
    Name: item.barberName,
    Card: item.card,
    Cash: item.cash,
    Squire: item.squire,
    'Gift Card': item.giftCard,
    Total: item.total,
    'Due to Barbers': item.dueToBarber,
    TaxAmount: item.taxAmount,
    'Due To Shop': item.dueToShop,
    commissionPercentage: item.commissionPercentage,
    'Hours Worked': item.totalTimeTracked,
  }));

  return {
    productReport: products,
    serviceReport: services,
  };
};

export const canLoadReport = (
  { reports: { startDate, endDate }, auth: { timezone } },
  exportReportDays = config.exportReportDays
) => {
  const start = moment.tz(startDate, config.dateFormat, timezone).startOf('day');
  const end = moment.tz(endDate, config.dateFormat, timezone).endOf('day');

  return Math.round(end.diff(start, 'days', true)) <= exportReportDays;
};

export const getGrossSalesKind = (currency, taxes) => ifElse(
  allPass([
    always(equals(currency, SHOP_CURRENCY.gbp)),
    always(equals(!!taxes, true)),
  ]),
  always(grossSalesKinds.grossSalesPlusTaxes),
  always(grossSalesKinds.default),
)();
